import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { SiteNav } from './site-nav';
import { SiteFooter } from './site-footer';

export function SiteLayout() {
  const loc = useLocation();

  // Reset scroll on route change unless an in-page anchor is being targeted.
  useEffect(() => {
    if (!loc.hash) window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [loc.pathname, loc.hash]);

  return (
    <div
      className="flex min-h-screen flex-col"
      style={{ background: 'var(--bg-canvas)', color: 'var(--fg-high)' }}
    >
      <SiteNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
